/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import ImagePath from 'app/utilities/imagePath';
import { downloadFactsheetAction, getPortofolioDetailAction } from 'app/redux/actions/PortofolioAction';
import { useDispatch, useSelector } from 'react-redux';
import { PortofolioDetailListInterface } from 'app/interfaces/lender/PortofolioDetailInterface';
import { RootState } from 'app/redux/store';
import rupiahCurrencyFormatter from 'app/utils/RupiahPipe';
import datePipe from 'app/utils/DatePipe';
import { ITextLabel } from 'app/interfaces/text-label/textLabel.interface';
import useComponentVisible from 'app/utils/VisibleComponent';
import { agreementAction, AGREEMENT_ENUM } from 'app/configs/portofolio.config';
import { portofolioDetailInit } from 'app/redux/reducers/PortofolioReducer';
import { generatePrivyFundingAction, IPrivyFundingResponse } from 'app/redux/actions/FundingAction';
import apiRequest from 'app/redux/api/api.request';
import { ApiRequestConfig } from 'app/interfaces/api-request/api.interface';
import endpoints from 'constants/endpoints';
import { useNavigate } from 'react-router-dom';
import ROUTER_PATH from 'app/routes/routerPath';
import LocalStorageService from 'app/services/localStorage';
import styles from './TableBarItem.module.scss';
import TextLabel from '../TextLabel/TextLabel';
import ShimmeringLoading from '../ShimmeringLoading/ShimmeringLoading';

export interface TableBarInterface {
	textLabel: ITextLabel[];
	index: string;
	loanStatus: string;
	transactionNumber?: string;
	loanNumber: string;
	propertyLenderId: string;
	loanSecureId?: string;
	subTextLabel: TableBarInterface[];
	docTokenUrl?: string;
	lenderAgreementFile?: string;
	lenderAgreementUrl?: string;
	factsheetUrl?: string;
	lastPage?: number;
	isSigned?: boolean;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	setReachBottom?: any,
	xignaturePpUrl?: string,
	xignaturePpfpUrl?: string,
	dgsignType?: string
}

const TableBarItem = function init(props: TableBarInterface): React.ReactElement {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const {
		textLabel,
		loanStatus,
		loanNumber,
		subTextLabel,
		docTokenUrl,
		// lenderAgreementFile,
		lastPage,
		lenderAgreementUrl,
		// setReachBottom,
		propertyLenderId,
		factsheetUrl,
		isSigned,
		xignaturePpUrl,
		xignaturePpfpUrl,
		dgsignType
	} = props;
	const [
		expand,
		setExpand
	] = useState(false);
	const [detail, setDetail] = useState(portofolioDetailInit);
	const [subItems, setSubItems] = useState(subTextLabel);
	const {
		portofolioDetail,
		pagination,
		loading,
	} = useSelector((state: RootState) => state.portofolioReducer);
	const [isLoading, setLoading] = useState(false);
	const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);
	const fundingState = useSelector((state: RootState) => state.fundingReducer);
	const { docToken } = fundingState;
	const [localPage, setLocalPage] = useState(1);

	function toggleItemDropdown(): void {
		if (!expand) {
			if (detail.detailList.length === 0
				|| portofolioDetail.propertyLenderId !== propertyLenderId) {
				dispatch(getPortofolioDetailAction({ propertyLenderId, page: 1, limit: 6 }));
				setSubItems([]);
			}
		}
		setExpand(!expand);
	}

	function getDownloadConfig(url: string): ApiRequestConfig {
		const userData = localStorage.getItem('user');
		let userToken = "";
		if (userData) {
			const resp = JSON.parse(userData);
			userToken = resp.token;
		}

		return {
			path: endpoints.api.DOWNLOAD_DOCUMENT,
			method: 'POST',
			headers: {
				Authorization: `Bearer ${userToken}`,
			},
			query: null,
			body: { document_url: url },
			timeout: 0,
			responseType: 'arraybuffer',
		};
	}

	function openPdfInNewTab(arrayBuffer: ArrayBuffer): void {
		const blob = new Blob([arrayBuffer], { type: 'application/pdf' });

		// Generate a URL for the Blob
		const url = URL.createObjectURL(blob);

		// Open the URL in a new tab
		window.open(url, '_blank');
	}

	function agreementItemOnClick(id: number): void {
		const xignature = 'XIGNATURE';
		if (id === AGREEMENT_ENUM.showAgreementFunding && dgsignType !== xignature) {
			if (isSigned) {
				const url = `${lenderAgreementUrl}`;
				window.open(url, '_blank');
			} else {
				const signPageTemp = 17;
				const privyConfig: IPrivyFundingResponse = {
					docToken: docTokenUrl as string,
					signCoordinatePage: lastPage || signPageTemp,
					digiSignId: LocalStorageService.getUserData().digiSignId
				};
				dispatch(generatePrivyFundingAction(privyConfig));
			}
		}

		if (id === AGREEMENT_ENUM.showAgreementFunding && dgsignType === xignature) {
			const config = getDownloadConfig(xignaturePpUrl || '');
			apiRequest(config).then((resp) => {
				openPdfInNewTab(resp);
			});
		}

		if (id === AGREEMENT_ENUM.showAgreementBorrower && dgsignType === xignature) {
			const config = getDownloadConfig(xignaturePpfpUrl || '');
			apiRequest(config).then((resp) => {
				openPdfInNewTab(resp);
			});
		}

		if (id === AGREEMENT_ENUM.downloadFactsheet) {
			if (factsheetUrl) {
				dispatch(downloadFactsheetAction({ document_url: factsheetUrl }));
			}
		}
	}

	useEffect(() => {
		if (docToken !== '') {
			navigate(ROUTER_PATH.privy);
		}
	}, [docToken]);

	function renderAgreementItem(): React.ReactElement {
		return (
			<div
				className={styles.agreement}
				ref={ref}
			>
				{isComponentVisible && agreementAction.map((each) => (
					<div
						role="button"
						tabIndex={0}
						onKeyPress={() => agreementItemOnClick(each.id)}
						key={each.label}
						className={styles.aggreementAction}
						onClick={() => agreementItemOnClick(each.id)}
					>
						{each.label}
					</div>
				))}
			</div>
		);
	}

	useEffect(() => {
		if (expand) {
			setExpand(!expand);
		}
	}, [pagination]);

	useEffect(() => {
		if (portofolioDetail && portofolioDetail.propertyLenderId === propertyLenderId) {
			const tableData: TableBarInterface[] = subItems;
			setLocalPage(localPage + 1);
			let i = 1;
			portofolioDetail.detailList.forEach((each: PortofolioDetailListInterface) => {
				const data: ITextLabel[] = [
					{
						title: 'Cicilan',
						value: each.paymentNo,
						bg: false
					},
					{
						title: 'Jatuh Tempo',
						value: datePipe(each.dueDate),
						bg: false
					},
					{
						title: 'Pembayaran Pokok',
						value: rupiahCurrencyFormatter(each.principalPayment),
						bg: false
					},
					{
						title: 'Pembayaran Bunga',
						value: rupiahCurrencyFormatter(each.interestPayment),
						bg: false
					},
					{
						title: 'Jumlah Denda',
						value: rupiahCurrencyFormatter(each.penaltyPayment),
						bg: false
					},
					{
						title: 'Jumlah Pajak',
						value: rupiahCurrencyFormatter(each.tax),
						bg: false
					},
					{
						title: 'Total Pembayaran',
						value: rupiahCurrencyFormatter(each.totalPaid),
						bg: false
					},
				];
				const tableItems = {
					index: `listPortofolioDetailItem${i.toString()}`,
					textLabel: data,
					loanStatus: each.statusName,
					loanNumber,
					propertyLenderId,
					subTextLabel: [],
				};
				i++;
				if (tableData.length < portofolioDetail.pagination.totalData) {
					tableData.push(tableItems);
				}
			});
			const temp = [...tableData];
			setSubItems(temp);
			const temp2 = {
				...portofolioDetail
			};
			setDetail(temp2);
		}
	}, [portofolioDetail]);

	useEffect(() => {
		const scroller = document.querySelector(`#sub${loanNumber}`);
		scroller?.addEventListener("scroll", () => {
			const {
				scrollTop,
				clientHeight,
				scrollHeight
			} = scroller;
			const reachBottom = Math.round(scrollTop + clientHeight) >= scrollHeight;
			if (reachBottom && !isLoading) {
				if (localPage <= portofolioDetail.pagination.totalPage) {
					dispatch(getPortofolioDetailAction({ propertyLenderId, page: localPage, limit: 6 }));
				}
				setLoading(true);
			}
			setLoading(false);
		});
	}, [detail, expand]);

	function loanStatusRender(status: string): React.ReactElement {
		switch (status) {
			case 'ACTIVE':
				return (
					<div className={styles.statusLabelGreen}>
						<span>
							{status}
						</span>
					</div>
				);
			case 'FUNDED':
				return (
					<div className={styles.statusLabelYellow}>
						<span>
							{status}
						</span>
					</div>
				);
			case 'LATE':
				return (
					<div className={styles.statusLabelRed}>
						<span>
							{status}
						</span>
					</div>
				);
			case 'RESTRUCTURE':
				return (
					<div className={styles.statusLabelGray}>
						<span>
							{status}
						</span>
					</div>
				);
			default:
				return (
					<div className={styles.statusLabel}>
						<span>
							{status}
						</span>
					</div>
				);
		}
	}

	function subStatusRender(status: string): React.ReactElement {
		switch (status) {
			case 'PAID':
				return (
					<div className={styles.subStatusLabelGreen}>
						<span>
							{status}
						</span>
					</div>
				);
			case 'ACTIVE':
				return (
					<div className={styles.subStatusLabelGray}>
						<span>
							{status}
						</span>
					</div>
				);
			case 'LATE':
				return (
					<div className={styles.subStatusLabelRed}>
						<span>
							{status}
						</span>
					</div>
				);
			default:
				return (
					<div className={styles.subStatusLabelGray}>
						<span>
							{status}
						</span>
					</div>
				);
		}
	}

	function loadingMoreData(): React.ReactElement | null {
		let haveMoreData = false;
		if (portofolioDetail.pagination) {
			haveMoreData = subItems.length < portofolioDetail.pagination.totalData;
			if (haveMoreData) {
				return (
					<div className={styles.subContent}>
						{textLabel.map((each: ITextLabel, index) => (
							<div
								key={`subItem${index}`}
								className={styles.value}
								style={{ width: each.width ? `${each.width}%` : `${(100 / textLabel.length)}%` }}
							>
								<TextLabel
									loading
									bg={each.bg}
									title={each.title}
									value={each.value}
									color={each.color}
									ellipsis={each.ellipsis}
								/>
							</div>
						))}
					</div>
				);
			}
			return null;
		}
		return null;
	}

	return (
		<div className="card">
			<div className={styles.content}>
				{textLabel && textLabel.map((each: ITextLabel, index) => (
					// eslint-disable-next-line react/no-array-index-key
					<div className={styles.value} key={index}>
						<TextLabel
							bg={each.bg}
							title={each.title}
							value={each.value}
							ellipsis={each.ellipsis}
							loading={loading}
						/>
					</div>
				))}
				<div className={styles.actionButton}>
					{loading ? <ShimmeringLoading height={24} width={75} /> : loanStatusRender(loanStatus)}
					{loading ? <ShimmeringLoading height={24} width={30} /> : (
						<button
							className={styles.toggleButton}
							type="button"
							onClick={() => setIsComponentVisible(!isComponentVisible)}
						>
							<img
								src={ImagePath.editDots.src}
								alt={ImagePath.editDots.alt}
							/>
							{renderAgreementItem()}
						</button>
					)}
					{loading ? <ShimmeringLoading height={24} width={30} /> : (
						<button
							className={styles.toggleButton}
							type="button"
							onClick={toggleItemDropdown}
							disabled={loanStatus === 'FUNDED'}
						>
							<img
								src={expand ? ImagePath.arrowUp.src : ImagePath.arrowDown.src}
								alt={expand ? ImagePath.arrowUp.alt : ImagePath.arrowDown.alt}
							/>
						</button>
					)}
				</div>
			</div>
			{
				expand && propertyLenderId === detail.propertyLenderId && (
					<div
						id={`sub${loanNumber}`}
						key={loanNumber}
						className={styles.subContentContainer}
						style={{ height: `${subItems.length > 5 ? "445px" : "fit-content"}` }}
					>
						{
							subItems && subItems.map((each: TableBarInterface, index) => (
								// eslint-disable-next-line react/no-array-index-key
								<div className={styles.subContent} key={index}>
									{each.textLabel && each.textLabel.map((label: ITextLabel, subIndex) => (
										// eslint-disable-next-line react/no-array-index-key
										<div key={subIndex} className={styles.value}>
											<TextLabel
												bg={label.bg}
												title={label.title}
												value={label.value}
												key={label.title + 1}
												ellipsis={label.ellipsis}
											/>
										</div>
									))}
									{subStatusRender(each.loanStatus)}
								</div>
							))
						}
						{loadingMoreData()}
					</div>
				)
			}
		</div>
	);
};

export default TableBarItem;
